'use client';

import { Trans } from "@lingui/react";
import { useResetPersistence } from '@segments/Storage';
import * as React from 'react';
import { useTrans } from '~logic/i18n/useTrans';
import { ModalBody } from '~ui/components/content/Modal/components/ModalBody';
import { ModalButton } from '~ui/components/content/Modal/components/ModalButton';
import { ModalFooter } from '~ui/components/content/Modal/components/ModalFooter';
import { ModalHeader } from '~ui/components/content/Modal/components/ModalHeader';
import { Modal } from '~ui/components/content/Modal/Modal';
import { IconLine } from '~ui/components/IconLine/IconLine';
import { IconAlert } from '~ui/components/icons/specific/IconAlert';
import { Flex, GridCentered } from '~ui/components/layout/Box';
import { Text } from '~ui/components/typography/Text/Text';
import { useWaiterRouter } from '../Routing/client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var fontSize = "m16";
/**
 * Error modal used by the app's error container to show some ~expected errors
 */

export var ErrorModal = function ErrorModal(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      headerText = _ref.headerText,
      errorText = _ref.errorText,
      _ref$allowAppRestart = _ref.allowAppRestart,
      allowAppRestart = _ref$allowAppRestart === void 0 ? false : _ref$allowAppRestart,
      _ref$allowMainButton = _ref.allowMainButton,
      allowMainButton = _ref$allowMainButton === void 0 ? true : _ref$allowMainButton,
      _ref$mainButtonLabel = _ref.mainButtonLabel,
      mainButtonLabel = _ref$mainButtonLabel === void 0 ?
  /*i18n*/
  {
    id: "zoPWd5"
  } : _ref$mainButtonLabel;

  var _useTrans = useTrans(),
      trans = _useTrans.trans;

  var router = useWaiterRouter();
  var resetPersistence = useResetPersistence();
  var restartApp = React.useCallback(function () {
    router.replace("home"); // TODO - test if works without .then

    resetPersistence({
      withAuth: true
    });
    window.location.reload();
    onClose();
  }, [onClose, resetPersistence, router]);

  var renderErrorMessages = function renderErrorMessages() {
    // errorText is not an array -> it's a string, render it as a single message
    if (!Array.isArray(errorText)) {
      return /*#__PURE__*/_jsx(Text, {
        children: errorText
      });
    }

    var hasMoreMessages = errorText.length > 1;
    var hasOneMessages = errorText.length === 1;

    if (hasMoreMessages) {
      return /*#__PURE__*/_jsx(_Fragment, {
        children: errorText.map(function (message) {
          return /*#__PURE__*/_jsx(Text, {
            children: message
          }, message);
        })
      });
    }

    return hasOneMessages ? /*#__PURE__*/_jsx(Text, {
      children: errorText[0]
    }) : null;
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Modal, {
      isOpen: isOpen,
      onClose: allowAppRestart ? restartApp : onClose,
      overlayZIndex: 100,
      children: [/*#__PURE__*/_jsx(ModalHeader, {
        bgColor: "specialColors.error",
        withCloseButton: true,
        children: /*#__PURE__*/_jsx(IconLine, {
          icon: IconAlert,
          children: /*#__PURE__*/_jsx(Text, {
            fontSize: fontSize,
            fontStyle: "boldSemi",
            maxWidth: "75%",
            children: headerText
          })
        })
      }), /*#__PURE__*/_jsx(ModalBody, {
        children: /*#__PURE__*/_jsx(GridCentered, {
          minHeight: "10rem",
          children: renderErrorMessages()
        })
      }), /*#__PURE__*/_jsx(ModalFooter, {
        bgColor: "bgColors.card",
        children: /*#__PURE__*/_jsxs(Flex, {
          flexGrow: 1,
          flexWrap: "wrap",
          columnGap: "medium",
          rowGap: "small",
          placeItems: "center",
          justifyContent: "center",
          children: [allowAppRestart && /*#__PURE__*/_jsx(ModalButton, {
            bgColor: "success",
            onClick: restartApp,
            children: /*#__PURE__*/_jsx(Trans, {
              id: "Mq+U2+"
            })
          }), allowMainButton && /*#__PURE__*/_jsxs(ModalButton, {
            bgColor: "error",
            onClick: onClose,
            children: [trans(mainButtonLabel), ' ']
          })]
        })
      })]
    })
  });
};